import { getQRZones } from "@/collections/qrZone";
const PRICES_SIZES = {
  base: "price",
  botella: "price_bottle",
  chupito: "price_shot",
  copa: "price_cup",
  cubata: "price_cubata"
};

export default {
  data() {
    return {
      qrZones: []
    };
  },
  computed: {
    tableQRFromQueryParam() {
      return this.$store.getters.getQR(this.$route.query.qr);
    },
    productTypeIds() {
      return this.$store.state.productTypeIds;
    }
  },
  mounted() {
    this.getQRZones().then();
  },
  methods: {
    async getQRZones() {
      try {
        this.qrZones = await getQRZones();
      } catch (error) {
        // eslint-disable-next-line
        this.setlogError(
          "get_qr_zones",
          "Obtained error message in getQRZones()",
          error.stack,
          this.$options.name
        );
      }
    },
    getPriceBySize(product, size) {
      return product[PRICES_SIZES[size]];
    },
    getCartProductQuantity(cart, order) {
      let productInCart = cart.find(item => item.order === order);
      let isMixProduct = cart.find(
        item => item.orderActual && item.orderActual === order
      );
      if (isMixProduct) {
        let mixProducts = cart.filter(
          item => item.orderActual && item.orderActual === order
        );
        let quantity = 0;
        mixProducts.forEach(product => {
          quantity += product.quantity;
        });

        return quantity;
      }

      return productInCart ? productInCart.quantity : null;
    },
    getOrder(product, size) {
      return size !== "base" ? `${product.name} - ${size}` : product.name;
    },
    getFoodOrder(product) {
      return product.name;
    },
    formatPrice(number) {
      return new Intl.NumberFormat("es-ES", {
        style: "currency",
        currency: "EUR"
      }).format(number);
    },
    formatPriceWithoutCurrency(number) {
      return new Intl.NumberFormat("es-ES", {}).format(number);
    },
    sizeText(item) {
      return item.size && item.size !== "base" ? item.size : "";
    },
    getCategoryName(categories, category_id) {
      const category = categories.find(category => category_id === category.id);
      return category ? category.name : "";
    },
    getSubCategoryName(subcategories, subcategory_id) {
      const subcategory = subcategories.find(
        subcategory => subcategory_id === subcategory.id
      );
      return subcategory ? subcategory.name : "";
    },
    getProductTypeName(productTypes, productType_id) {
      const productType = productTypes.find(
        productType => productType_id === productType.id
      );
      return productType ? productType.name : "";
    },
    getFirstLetter(value) {
      return value ? value.charAt(0) : value;
    },
    displayMenu(menu) {
      if (
        menu &&
        menu.drink_ids &&
        menu.drink_ids.length === 0 &&
        menu.food_ids &&
        menu.food_ids.length === 0 &&
        menu.dessert_ids &&
        menu.dessert_ids.length === 0
      ) {
        return false;
      }

      // for menu group
      if (
        menu &&
        menu.drink_ids &&
        menu.drink_ids.length === 0 &&
        menu.dessert_ids &&
        menu.dessert_ids.length === 0 &&
        menu.maincourse_ids &&
        menu.maincourse_ids.length === 0 &&
        menu.starter_ids &&
        menu.starter_ids.length === 0
      ) {
        return false;
      }

      let qrZone = this.findZone();
      if (qrZone) {
        let findAll = qrZone?.selectedMenu?.some(item => {
          if (item === "all") {
            return item;
          }
        });

        if (findAll) {
          return true;
        }

        let selectedMenuByZone = qrZone.selectedMenu;
        return selectedMenuByZone.some(x => {
          if (x === menu.id) {
            return x;
          }
        });
      } else {
        return false;
      }
    },
    displayComidas() {
      return this.displayProduct(process.env.VUE_APP_PRODUCT_TYPE_FOOD_ID);
    },
    displayBebidas() {
      return this.displayProduct(process.env.VUE_APP_PRODUCT_TYPE_DRINKS_ID);
    },
    displayPostres() {
      return this.displayProduct(process.env.VUE_APP_PRODUCT_TYPE_DESSERT_ID);
    },
    displayProduct(productTypeId) {
      if (!this.tableQRFromQueryParam) {
        return true;
      }

      let qrZone = this.findZone();
      if (qrZone) {
        let findAll = qrZone?.selectedMenu?.some(item => {
          if (item === "all") {
            return true;
          }
        });

        if (findAll) {
          return true;
        }

        let selectedMenuByZone = qrZone.selectedMenu;

        return selectedMenuByZone?.some(x => {
          if (x === productTypeId) {
            return x;
          }
        });
      }
    },
    findZone() {
      if (this.qrZones.length === 0) {
        this.getQRZones();
      }

      if (
        !this.tableQRFromQueryParam ||
        (this.tableQRFromQueryParam &&
          this.tableQRFromQueryParam.zone_id === undefined)
      ) {
        return null;
      }

      return this.qrZones.find(qrZone => {
        if (qrZone.id === this.tableQRFromQueryParam.zone_id) {
          return qrZone;
        }
      });
    },
    totalWithAdditionalCharge(item) {
      let total = 0;
      if (item.starters) {
        item.starters.forEach(starter => {
          total += parseFloat(starter.additional_charge) * item.quantity;
        });
      }
      if (item.maincourse) {
        item.maincourse.forEach(main => {
          total += parseFloat(main.additional_charge) * item.quantity;
        });
      }

      if (item.desserts) {
        item.desserts.forEach(dessert => {
          total += parseFloat(dessert.additional_charge) * item.quantity;
        });
      }

      if (item.desserts) {
        item.drinks.forEach(drink => {
          total += parseFloat(drink.additional_charge) * item.quantity;
        });
      }
      return total;
    },
    validMenuProducts(menu) {
      let allProductIds = [
        ...menu.food_ids,
        ...menu.drink_ids,
        ...menu.dessert_ids
      ];
      let allProducts = [...this.food, ...this.drinks, ...this.dessert];
      let filterProducts = allProducts.filter(item => {
        if (allProductIds.includes(item.id) && item.stock > 0) {
          return item;
        }
      });
      return filterProducts && filterProducts.length > 0;
    },
    validMenuGroupProducts(menu) {
      try {
        let allProductIds = [
          ...menu.drink_ids,
          ...menu.dessert_ids,
          ...(menu.maincourse_ids ? menu.maincourse_ids : []),
          ...(menu.starter_ids ? menu.starter_ids : [])
        ];
        let allProducts = [
          ...(this.food ? this.food : []),
          ...(this.drinks ? this.drinks : []),
          ...(this.dessert ? this.dessert : [])
        ];
        let filterProducts = allProducts
          ? allProducts.filter(item => {
              let found = allProductIds.some(id => id.id === item.id);

              if (found && item.stock > 0) {
                return item;
              }
            })
          : [];

        return filterProducts && filterProducts.length > 0;
      } catch (error) {
        console.log("error", error);
      }
    },
    getTaxBase(value) {
      return (parseFloat(Number(value)) / parseFloat(Number(1.1))).toFixed(2);
    },
    getIVA(value) {
      return (
        parseFloat(Number(value)) -
        parseFloat(Number(value)) / parseFloat(Number(1.1))
      ).toFixed(2);
    }
  },
  // is used in the store
  stripeFormatPrice(price) {
    return (price * 100).toFixed(0);
  }
};
